import { Button } from "@coval/ui"
import { Pause, Play } from "lucide-react"

interface MotionPauseButtonProps {
  isStill: boolean
  onToggle: () => void
  /** What moves, completing the "Pause …" and "Play …" name. */
  subject?: string
  className?: string
}

/** Icon button that pauses and plays content that moves on its own. */
export function MotionPauseButton({
  isStill,
  onToggle,
  subject = "animation",
  className,
}: MotionPauseButtonProps) {
  return (
    <Button
      variant="ghost"
      icon
      tooltip={`${isStill ? "Play" : "Pause"} ${subject}`}
      className={className}
      onClick={onToggle}
    >
      {isStill ? <Play /> : <Pause />}
    </Button>
  )
}
